// ** Types
export type { IconRenderProps as GraphTableIconProps } from '@/components/common/icons';

// ** Components
export { GraphIcon, TableIcon } from '@/components/common/icons';
